import React from 'react';
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-text-mask';
import { useUiField } from '../hooks';
import { UiField } from './UiField';

export function UiDatePicker(props) {
  const [uiFieldProps, inputProps] = useUiField(props);

  return (
    <UiField {...uiFieldProps}>
      <DatePicker
        dateFormat="MM/dd/yyyy"
        {...inputProps}
        autoComplete="off"
        customInput={
          <MaskedInput
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
          />
        }
      />
    </UiField>
  );
}
